/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AgentAssistantMode } from './AgentAssistantMode';
import {
    AgentAssistantModeFromJSON,
    AgentAssistantModeFromJSONTyped,
    AgentAssistantModeToJSON,
    AgentAssistantModeToJSONTyped,
} from './AgentAssistantMode';

/**
 * 
 * @export
 * @interface AgentChatDto
 */
export interface AgentChatDto {
    /**
     * アシスタントの回答モード。省略時は developer_api（後方互換）。
     * 新規セッション開始時のみ参照され、agentId 指定時は無視される。
     * @type {AgentAssistantMode}
     * @memberof AgentChatDto
     */
    mode?: AgentAssistantMode;
    /**
     * ユーザーメッセージ
     * @type {string}
     * @memberof AgentChatDto
     */
    message: string;
    /**
     * 前回のレスポンスで返された agentId。指定するとその会話を継続する。
     * 省略時は新しい会話を開始する。
     * @type {string}
     * @memberof AgentChatDto
     */
    agentId?: string;
}



/**
 * Check if a given object implements the AgentChatDto interface.
 */
export function instanceOfAgentChatDto(value: object): value is AgentChatDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AgentChatDtoFromJSON(json: any): AgentChatDto {
    return AgentChatDtoFromJSONTyped(json, false);
}

export function AgentChatDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentChatDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'] == null ? undefined : AgentAssistantModeFromJSON(json['mode']),
        'message': json['message'],
        'agentId': json['agentId'] == null ? undefined : json['agentId'],
    };
}

export function AgentChatDtoToJSON(json: any): AgentChatDto {
    return AgentChatDtoToJSONTyped(json, false);
}

export function AgentChatDtoToJSONTyped(value?: AgentChatDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': AgentAssistantModeToJSON(value['mode']),
        'message': value['message'],
        'agentId': value['agentId'],
    };
}

